import type { ReactNode } from 'react'

import AcceptInvitePage from './AcceptInvitePage'
import { isInviteLinkPath } from './inviteLink'

/**
 * Answers an invite link before the app's providers exist.
 *
 * The page is public — the person has no session — and it holds the invite
 * token in memory only. Rendered inside the providers it was one stale
 * `cmos_token` away from losing it: the shared API client's 401 handler clears
 * the session and reloads the document, and a reload finds no token (it was
 * taken off the URL) and replaces the form with "open the emailed link".
 * LocalAuthProvider, AuthProvider (MSAL) and DemoDataProvider can all issue
 * authenticated requests on mount, so none of them may be mounted here.
 *
 * `children` are elements, not mounted components: on an invite path they are
 * never rendered, so no provider runs. Any other path is untouched.
 */
export default function InviteGate({ children }: { children: ReactNode }) {
  if (isInviteLinkPath(window.location.pathname)) return <AcceptInvitePage />
  return <>{children}</>
}
